<style>
</style>
<template>
    <span>{{ diff }}</span>
</template>

<script>
    export default {
        props: ['start-at', 'end-at', 'diff-result'],

        computed: {
            diff: function() {
                var startAtTimestamp = Date.parse(this.startAt)
                var endAtTimestamp = Date.parse(this.endAt)

                if (!startAtTimestamp || !endAtTimestamp) {
                    return '';
                }


                var diff = endAtTimestamp - startAtTimestamp;

                var seconds = diff / 1000

                var minute = Math.floor(seconds / 60) % 60;

                var hour = Math.floor(seconds / 3600);

                return hour + '小時' + minute + '分';
            },

            diffRaw: function () {
                var startAtTimestamp = Date.parse(this.startAt)
                var endAtTimestamp = Date.parse(this.endAt)

                return  endAtTimestamp > startAtTimestamp;
            },
        },

        data() {
            return {
            }
        },

        methods: {
        },

        mounted() {
        }
    }
</script>
